import { Component } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Location }                 from '@angular/common';
import { OrderService } from './services/order.service';
import { OnInit } from '@angular/core';
import {ProductService} from "./services/product.service";
import {Product} from "./model/Product";
import {Photo} from "./model/Photo";
import {Type} from "./model/Type";
import {TypeService} from "./services/type.service";

import 'rxjs/add/operator/switchMap';
import {FileHolder} from "angular2-image-upload/lib/image-upload/image-upload.component";
import {PhotoService} from "./services/photo.service";
import {AuthenticationService} from "./services/authentication.service";
import {environment} from "../environments/environment";

@Component({
    selector: 'app-admin-edit-product',
    templateUrl: './edit-product.component.html',
    /*styleUrls: ['./app.component.css'],*/
    providers: [ProductService, TypeService, PhotoService]
})

export class EditProductComponent implements OnInit {
    ngOnInit(): void {
        this.getListTypes();
        this.route.params.subscribe(params => {
            let id:number = +params['id'];
            if(id !== -1) {
                this.route.paramMap
                    .switchMap((params: ParamMap) => this.productService.getProduct(+params.get('id')))
                    .subscribe(product => this.mProduct = product);
            } else {
                this.mProduct = new Product();
                this.mProduct.active = true;
                this.mProduct.type = new Type();
            }
        });

        this.photo = new Photo();


    }
    title = 'Edit product';
    mProduct:Product;

    constructor(private productService : ProductService,
                private typeService : TypeService,
                private photoService : PhotoService,
                private route: ActivatedRoute,
                private location: Location,
                private authenticateService: AuthenticationService) {}
    order = null;
    product: Product;
    photo: Photo;
    listTypes: Type[];
    selectedType:number;
    imageBaseUri: string = environment.imageBaseUri;
    instantPaiementApi: string = environment.instantPaiementApi;

    getToken() {
        return this.authenticateService.getToken();
    }

    get diagnostic() { return "chaine = " + JSON.stringify(this.mProduct); }
    getListTypes(): void {
        this.typeService.getListTypes().then((listTypes) => {
            this.listTypes = listTypes
        }, (error) => {
            console.error(error);
        })
    }

    addProduct(): void {
        this.mProduct.photo = this.photo;
        this.productService.addProduct(this.mProduct)
            .then(
                product  => /*this.heroes.push(hero)*/console.error(product),
                error =>  /*this.errorMessage = <any>error*/console.error(error));
    }

    onUploadFinished(file: FileHolder) {
        alert(JSON.stringify(file.serverResponse));
    }

    onRemoved(file: FileHolder) {
        // do some stuff with the removed file.
    }

    onUploadStateChanged(state: boolean) {
        alert(JSON.stringify(state));
    }

    imageUploaded(event) {
        let serverResponse = event.serverResponse;
        let response = JSON.parse(serverResponse._body);

        let result = response.result;
        let idPhoto = response.id;
        let urlPhoto = response.url;
        if(result) {
            this.photo.id = idPhoto;
            this.photo.url = urlPhoto;
        } else {
            alert(response.error);
        }
    }

    imageRemoved(event) {
        console.log("imageRemoved : " + JSON.stringify(event));
        let serverResponse = event.serverResponse;
        let response = JSON.parse(serverResponse._body);

        let idPhotoToDelete = response.id;

        if(idPhotoToDelete != null) {
            this.photoService.removePhoto(idPhotoToDelete).then((listProducts) => {
                //console.error("taille dans le app.component = " + listProducts);

            }, (error) => {
                console.error(error);
            });
        }

    }
}



// WEBPACK FOOTER //
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/app/edit-product.component.ts